import script from "./repayment.vue?vue&type=script&setup=true&lang=js"
export * from "./repayment.vue?vue&type=script&setup=true&lang=js"

import "./repayment.vue?vue&type=style&index=0&id=0d676950&lang=less&scoped=true"

import exportComponent from "E:\\zhengbo-supplychain\\web-supplychain\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0d676950"]])

export default __exports__